import { post } from '@namespace/helpers';

export const setTimezone = (tz) =>
  post({ url: '/bets/timezone/set/', body: `tz=${tz}`, timeout: 11000 });
